<template>
  <section :id="side">
    <div class="tempo-container">
      <div class="tempo" @dblclick="resetTempo" />
    </div>
    <div class="load" @click="loadSong"></div>
    <div class="sync"></div>
    <div class="play" @click="togglePlay"></div>
    <div class="less" @click="rewind"></div>
    <div class="more" @click="forward"></div>
    <div :class="['jog', isPlaying ? 'running' : 'paused']">
      <div class="wave"></div>
    </div>
    <div class="volume-container">
      <div class="volume" />
    </div>
    <div class="info">
      <div class="song">{{ currentSong }}</div>
      <div class="info-time">{{ currentTime }}</div>
      <div class="info-tempo">
        <span>TEMPO: </span><strong>±{{ tempoPercentage }}<span> %</span></strong>
      </div>
      <input type="range" :min="0" :max="duration" v-model="currentTime">
    </div>
  </section>
</template>

<script>
export default {
  props: ['side'],
  data() {
    return {
      isPlaying: false,
      currentSong: '',
      currentTime: '00:00',
      duration: 0,
      tempoPercentage: '0.00',
      audio: null,
    };
  },
  methods: {
    togglePlay() {
      if (this.audio) {
        this.isPlaying = !this.isPlaying;
        this.isPlaying ? this.audio.play() : this.audio.pause();
      } else {
        this.loadSong();
      }
    },
    loadSong() {
      // Logic to load a song and update the audio source
      // Use props or emit events to control other components
    },
    resetTempo() {
      this.tempoPercentage = '0.00';
      this.audio.playbackRate = 1;
    },
    rewind() {
      if (this.audio) {
        this.audio.currentTime -= 0.1;
      }
    },
    forward() {
      if (this.audio) {
        this.audio.currentTime += 0.1;
      }
    }
  }
};
</script>
